// Define the domain first
const frontendDomain = "https://peacekeeper.duredemos.com"; // UAT
// const frontendDomain = "http://localhost:3000";
//const frontendDomain = "https://i-am-peacekeeper.com";   // Live

export const Configuration = {
  mobileAppVersion: "1.0.5", // Must match version_number from /version/current API
  mobileAppMode: "debug",
  mobileAppDownloadUrl:
    "https://play.google.com/store/apps/details?id=com.duretechnologies.apps.android.peacekeeper",
  mobileAppiOSUrl: "https://apps.apple.com/in/app/i-am-peacekeeper-movement/id6751220263",
  frontendDomain, // ES6 shorthand for frontendDomain: frontendDomain

  apiService: {
    key: `${frontendDomain}/serviceuat/`,
  },
  apiSurvey: {
    key: `${frontendDomain}/serviceuat/`,
  },
};
